/**
 * Re-packaging overwrites the SAME artifact URLs, so a fresh load needs a
 * cache-busting query param. The artifact host ignores it; the browser's
 * cache doesn't hit. `token` is the version's `packagedAt` — stamped when the
 * artifact was written, so it moves exactly when the content changed.
 */
export function cacheBustHtmlKeys(
  htmlKeys: Record<string, string> | null | undefined,
  token: string | null | undefined,
): Record<string, string> | null {
  if (!htmlKeys) return null;
  if (!token) return htmlKeys;
  const suffix = `?t=${encodeURIComponent(token)}`;
  return Object.fromEntries(
    Object.entries(htmlKeys).map(([dimension, url]) => [dimension, `${url}${suffix}`]),
  );
}
